<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-card style="margin: 5px">
            <v-card-title>
                <v-container>
                    <v-layout v-show="is_captain">
                        <v-flex xs12>
                            <choose-date v-model="range.from"></choose-date>
                        </v-flex>
                        <v-flex xs12>
                            <choose-date v-model="range.to"></choose-date>
                        </v-flex>
                        <v-flex>
                            <v-btn @click="show" color="primary">Show</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container row wrap>
                    <v-layout style="margin-bottom: 15px">
                        <v-flex xs12>
                            <h2 style="text-align: center"><b>Week: </b>{{moment(payment_info.range[1]).weeksInYear()}}
                            </h2>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs6>
                            <p style="text-align: center"><b>Captain ID: {{payment_info.captain_id}}</b></p>
                        </v-flex>
                        <v-flex xs6>
                            <router-link style="text-align: center;text-decoration: none"
                                         :to="'/captains/' + payment_info.captain_id" target="_blank"><b>Captain:
                                {{payment_info.captain_name}}</b></router-link>
                        </v-flex>
                        <v-flex xs4 v-show="payment_info.id">
                            <p style="text-align: center"><b>Payment ID: {{payment_info.id}}</b></p>
                        </v-flex>
                        <v-flex xs8>
                            <p style="text-align: center">
                                <b>From: {{moment(payment_info.range[0]).format('DD MMM YYYY hh:mm A')}}</b>
                            </p>
                        </v-flex>
                        <v-flex xs8>
                            <p style="text-align: center">
                                <b>To: {{moment(payment_info.range[1]).format(`DD MMM YYYY hh:mm A`)}}</b>
                            </p>
                        </v-flex>
                    </v-layout>
                </v-container>
                <div style="margin: auto">
                    <v-rating
                            style="display: inline"
                            v-model="overall.average_rating"
                            background-color="yellow accent-4"
                            color="yellow accent-4" readonly
                            dense half-increments hover x-large
                    ></v-rating>
                    <span v-if="overall.total_ratings > 0" class="grey--text text--lighten-2 caption mr-2">
                        ({{overall.average_rating}} from {{overall.total_ratings}} rate)
                    </span>
                    <span v-else class="grey--text text--lighten-2 caption mr-2">
                        no ratings
                    </span>
                </div>

                <h4 style="text-align: center;width: 100%;margin:25px 0">
                    <v-layout center style="margin: 10px;">
                        <v-flex xs12 :style="[overall.from_old_payments >= 0 ? {color:'red'} : {color:'green'}]">
                            Rest from old payments: {{overall.from_old_payments}} <strong> S.P</strong>
                        </v-flex>
                    </v-layout>
                    <v-layout center style="margin: 10px;">
                        <v-flex xs6>
                            Revenue: {{overall.revenue}}<strong> S.P</strong>
                        </v-flex>
                        <v-flex xs6>
                            Meters: {{overall.rides_value}}<strong> S.P</strong>
                        </v-flex>
                        <v-flex xs6>
                            <a style="text-underline: none" @click="openDialog('bonus')">Bonus:
                                {{overall.bonus}}<strong> S.P</strong></a>
                        </v-flex>
                        <v-flex xs6>
                            DUE: {{overall.payroll}}<strong> S.P</strong>
                        </v-flex>
                        <v-flex xs6
                                :style="[overall.revenue - overall.payroll - overall.bonus < 0 ? {color:'red'} : {color:'green'}]">
                            Profit: {{overall.revenue - overall.payroll - overall.bonus}}<strong> S.P</strong>
                        </v-flex>
                    </v-layout>
                    <v-layout center style="margin: 10px;">
                        <v-flex xs6>
                            Cash received: {{overall.cash}}<strong> S.P</strong>
                        </v-flex>
                        <v-flex xs6>
                            Tips: {{overall.tips}}<strong> S.P</strong>
                        </v-flex>
                        <v-flex xs6>
                            <a style="text-underline: none" @click="openDialog('penalties')">Penalties On:
                                {{overall.penalties_on}}<strong> S.P</strong></a>
                        </v-flex>
                        <v-flex xs6>
                            Penalties For: {{overall.penalties_for}}<strong> S.P</strong>
                        </v-flex>
                        <v-flex xs6 :style="[overall.rest >= 0 ? {color:'red'} : {color:'green'}]">
                            Closing balance: {{overall.rest}}<strong> S.P</strong>
                        </v-flex>
                    </v-layout>
                </h4>
                <p>Payment Details</p>
            </v-card-title>
            <v-data-table :headers="headers" :items="desserts" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.reason }}</td>
                    <td class="text-xs-left">{{ round(props.item.quantity, 1) }}
                        <strong>{{props.item.unit}}</strong>
                    </td>
                    <td class="text-xs-left">{{ round(props.item.overall, 1) }} <strong>SP</strong></td>
                    <td>
                        <v-icon @click="openDialog(props.item.reason)">info</v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="85%">
            <v-card v-if="dialog_type">
                <v-card-title>
                    <span class="headline">{{dialog_type}} Details</span>
                </v-card-title>
                <v-card-text>
                    <DataTable
                            :url.sync="url"
                            :row-call-back="rowCallBack"
                            :conditional-action="conditionalActions"
                            :is_expanded="dialog_type === 'Rides'"
                            expand_url="payment/ride"
                            :enable-edit="false"
                            :enable-delete="false"
                            :enable-add="false"
                            :disable-search="true"
                            :actions-extra-main="actionsExtraMain"
                            :fieldsHiddenMain='["deleted_at", "entry_deleted_at"]'/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog :value="!!ride_id" @input="ride_id = null" width="70%">
            <v-card v-if="!!ride_id">
                <v-card-text>
                    <RidePage :ride_id="ride_id"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="confirm_dialog.visible" width="500">
            <v-card>
                <v-card-title class="headline red lighten-2" primary-title>
                    Warning
                </v-card-title>
                <v-card-text>
                    Are you sure you want to {{confirm_dialog.text}}?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click="confirm">
                        I accept
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import LoadingComponent from "@/components/LoadingComponent";
    import RidePage from "@/views/RidePage";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";

    export default {
        name: "Report",
        title: 'Report',
        components: {ChooseDate, RidePage, LoadingComponent, DataTable},
        props: {
            is_captain: {
                type: Boolean,
                default: false
            },
            id: {}
        },
        computed: {
            conditionalActions() {
                return {
                    revoke: (item) => !item.entry_deleted_at && this.hasPermission('FLIP_RIDE_ENTRY_STATE'),
                    revokeUndo: (item) => item.entry_deleted_at && this.hasPermission('FLIP_RIDE_ENTRY_STATE')
                }
            },
            actionsExtraMain() {
                console.log(this.dialog_type);

                if (!this.hasPermission('MANAGE_TRANSACTION')) {
                    return {};
                }
                if (this.dialog_type === 'Rides') {
                    return {
                        details: {
                            title: 'Details',
                            extras: {
                                medium: true
                            },
                            action: ({id}) => {
                                this.ride_id = id.toString();
                            }
                        },
                        revoke: {
                            title: "Revoke Ride entries",
                            icon: 'delete_forever',
                            extras: {
                                medium: true
                            },
                            action: (item) => {
                                this.confirm_dialog.text = 'revoke this ride entry';
                                this.confirm_dialog.selected = item;
                                this.confirm_dialog.visible = true;
                                this.confirm_dialog.type = 'ride';
                            }
                        },
                        revokeUndo: {
                            title: "undo Revoke Ride entries",
                            icon: 'undo',
                            extras: {
                                medium: true
                            },
                            action: (item) => {
                                this.confirm_dialog.text = 'undo revoke this ride entry';
                                this.confirm_dialog.selected = item;
                                this.confirm_dialog.visible = true;
                                this.confirm_dialog.type = 'ride';
                            }
                        }
                    }
                } else if (this.dialog_type === 'bonus') {
                    return {
                        revoke: {
                            title: "Revoke Ride entries",
                            icon: 'delete_forever',
                            extras: {
                                medium: true
                            },
                            action: (item) => {
                                this.confirm_dialog.text = 'revoke this bonus';
                                this.confirm_dialog.selected = item;
                                this.confirm_dialog.visible = true;
                                this.confirm_dialog.type = 'bonus';
                            }
                        }
                    };
                } else if (this.dialog_type === 'Bookings') {
                    return {
                        details: {
                            title: 'Details',
                            extras: {
                                medium: true
                            },
                            action: ({ride_id}) => {
                                this.ride_id = ride_id.toString();
                            }
                        }
                    }
                } else if (this.dialog_type === 'penalties') {
                    return {
                        revoke: {
                            title: "Revoke Penalty",
                            icon: 'delete_forever',
                            extras: {
                                medium: true
                            },
                            action: (item) => {
                                this.confirm_dialog.text = 'revoke this penalty';
                                this.confirm_dialog.selected = item;
                                this.confirm_dialog.visible = true;
                                this.confirm_dialog.type = 'penalties';
                            }
                        }
                    };
                }
                return {};
            }
        },
        data() {
            return {
                ride_id: null,
                range: {},
                rowCallBack: (item) => {
                    if (this.dialog_type === 'Rides' && item.entry_deleted_at) return ["revoked-ride"];
                    return [];
                },
                confirm_dialog: {
                    visible: false,
                    text: '',
                    selected: null
                },
                loading: false,
                dialog: false,
                transactionDialog: false,
                url: ``,
                dialog_type: '',
                headers: [
                    {text: 'Reason', value: 'reason', sortable: false},
                    {text: 'Quantity', value: 'quantity', sortable: false},
                    {text: 'Earnings', value: 'overall', sortable: false},
                    {text: 'Actions', value: 'actions', sortable: false},
                ],
                desserts: [],
                overall: {
                    from_old_payments: 0,
                    revenue: 0,
                    penalties_for: 0,
                    penalties_on: 0,
                    total_ratings: 0,
                    cash: 0,
                    rides_value: 0,
                    bonus: 0,
                    payroll: 0,
                    tips: 0
                },
                payment_info: {range: ['', '']}
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            confirm() {
                let path = '';
                switch (this.confirm_dialog.type) {
                    case "ride":
                        path = `ride/${this.confirm_dialog.selected.id}/entry/flip`;
                        break;
                    case "bonus":
                        path = `bonus_entry_detail/${this.confirm_dialog.selected.id}`;
                        break;
                    case "penalties":
                        path = `${this.api.ACTIONS.PENALTY}/${this.confirm_dialog.selected.id}`;
                }
                this.axios({
                    method: this.confirm_dialog.type === 'ride' ? 'put' : 'delete',
                    url: path
                }).then(res => {
                    if (res.data.data) {
                        this.confirm_dialog.selected.entry_deleted_at = null;
                    } else {
                        this.confirm_dialog.selected.entry_deleted_at = this.moment().format('YYYY-MM-DD HH:mm:ss');
                    }
                    this.confirm_dialog = {};
                })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    });
            },
            reset() {
                this.transactionDialog = this.loading = this.dialog = false;
                this.desserts = [];
                this.overall = {};
                this.payment_info = {range: ['', '']};
                this.url = this.dialog_type = '';
            },
            show() {
                console.log(this.range);
                if (this.range.from && this.range.to && this.range.from <= this.range.to) {
                    this.getData();
                } else {
                    window.getApp.$emit('SHOW_TOAST', 'invalid range', 'red');
                }
            },
            getData() {
                this.loading = true;
                let url = ``;
                if (this.is_captain) {
                    url = `payment/ongoing/${this.id}`;
                    if (this.range.from && this.range.to) {
                        url += `?from=${this.range.from}&to=${this.range.to}`;
                    }
                } else {
                    url = `payment/${this.id}`;
                }
                this.axios.get(url)
                    .then(res => {
                        this.$emit('status', res.data.data.status);
                        this.desserts = [];
                        Object.keys(res.data.data.tables).forEach(elem => {
                            res.data.data.tables[elem].reason = elem;
                            this.desserts.push(res.data.data.tables[elem]);
                        });
                        res.data.data.overall.average_rating = this.round(res.data.data.overall.average_rating, 1);
                        this.overall = res.data.data.overall;
                        this.payment_info = res.data.data.info;
                    })
                    .catch(err => {
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed cannot get requested report';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    }).finally(() => this.loading = false);
            },
            openDialog(type) {
                if (type === 'Rides') {
                    this.url = `payment/rides` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                } else if (type === 'Hours') {
                    this.url = `payment/hours` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                } else if (type === 'Rides KM Meter') {
                    this.url = `payment/rides_km` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                } else if (type === 'Ghost Rides KM Meter') {
                    this.url = `payment/ghost_rides_km` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                } else if (type === 'bonus') {
                    this.url = `payment/bonus` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                } else if (type === 'penalties') {
                    this.url = `payment/penalties` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                } else if (type === 'Bookings') {
                    this.url = `payment/bookings` + (this.is_captain ? `?captain_id=` : '/') + this.id;
                }
                if (this.is_captain && this.range.from && this.range.to) {
                    this.url += `&from=${this.range.from}&&to=${this.range.to}`;
                }
                this.dialog_type = type;
                this.dialog = true;
            },
            round(val, point_cnt = 2) {
                if (!isNaN(val))
                    return Math.round((val) * Math.pow(10, point_cnt)) / Math.pow(10, point_cnt);
                return val;
            },
        }
    }
</script>

<style lang="scss">
    .overlay {
        width: 0;
    }

    .overlaid {

        .overlay {
            position: fixed;
            width: 100vw;
            height: 100vh;
            z-index: 1000;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
        }

        .expanded {
            z-index: 1001;
        }
    }

    .revoked-ride {
        background: red;
    }
</style>